import Vue from 'vue';
import Router from 'vue-router';
import ls from '../services/ls';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/simulator/rules',
      name: 'rules',
      component: () => import('../views/simulator/Rules.vue'),
      meta: {
        title: 'Правила',
      },
    },
    {
      path: '/simulator/list',
      name: 'list',
      component: () => import('../views/simulator/QuestionList.vue'),
      meta: {
        title: 'Список вопросов',
      },
    },
    {
      path: '/simulator/errors',
      name: 'errors',
      component: () => import('../views/simulator/QuestionErrors.vue'),
      meta: {
        title: 'Вопросы с ошибками',
      },
    },
    {
      path: '/simulator/phone',
      name: 'phone',
      component: () => import('../views/simulator/Phone.vue'),
      meta: {
        title: 'Симулятор недоступен',
      },
    },
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  ls.set('pdd-settings', JSON.stringify(Vue.prototype.$appSettings));

  next();
});

router.afterEach(() => {
  Vue.prototype.$appSettings = JSON.parse(ls.get('pdd-settings'));
});

export default router;
